import { useApiQuery } from 'mf_core/query';

export function useGetNotificationHistory() {
  return useApiQuery<any>(
    `/account-management/v1/notifications/history?Page=1&Size=10&NotificationType=inapp&onlySummary=true`
  );
}
